/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface TypePrice {
  id: number;
  header: string;
  syncUid: string;
  createdAt: Date;
  enabled: boolean;
  deleted?: boolean;
}
